<template>
  <div>
    <v-btn
      class="raison-btn rai-btn ma-2 pa-4 darken-3"
      @click="$emit('click', $event)"
      :disabled="disabled"
      >
      {{ $t(shortLabelCode) }}
    </v-btn>
    {{ $t(answerLabelCode) }}
  </div>
</template>

<script>

export default {
  name: 'FavoriteOption',

  props: {
    shortLabelCode: {
      type: String,
      required: true
    },
    answerLabelCode: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
    }
  },

  methods: {
  },
};
</script>

<style>
.v-btn__content {
  white-space: normal;
  flex: auto;
}
</style>
